import { createStore } from 'redux';
import Reducer from "./Reducers";

const ReduxStore = createStore(Reducer);

export default ReduxStore;